module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("h5ipB"))).then(() => parcelRequire('1iHdE'));